import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/exchangeRates'

export default {
  async getAll(providerRate) {
    return await axios
      .get(endpoint + `/list/${providerRate}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getAllProviders() {
    return await axios
      .get(endpoint + '/list/providers')
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getMapping() {
    return await axios
      .get(endpoint + '/item/map')
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getCurrencySelection() {
    return await axios
      .get(endpoint + '/list/currency')
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async createMapping(request) {
    return await axios
      .post(endpoint + '/map', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async updateMapping(request) {
    return await axios
      .put(endpoint + '/map', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async updateRate(request) {
    return await axios
      .put(endpoint + '/rate', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/exchangeRate/exchangeRateService.js